import type { FunctionComponent, SVGAttributes } from "preact";
import type { IconName } from "./feather_icon_name.d.ts";
import { useMemo } from "preact/hooks";
import { useMergedClassName } from "../utils.ts";

export type IconProps = SVGAttributes<SVGSVGElement> & {
    name: IconName;
    size?: number | string;
};

const SVG_ICON_BASE_PATH = "/static/camera/svg/feather-sprite.svg#";

export const Icon: FunctionComponent<IconProps> = (props: IconProps) => {
    const { name, size = 24, class: classNameProp, ...rest } = props;
    const className = useMergedClassName("tinyui_svg_icon", classNameProp);
    const iconHref = useMemo(() => {
        return SVG_ICON_BASE_PATH + name;
    }, [name]);
    
    return (
        <svg
            {...rest}
            class={className}
            width={size}
            height={size}
            stroke="currentColor"
            fill="none"
        >
            <use href={iconHref} />
        </svg>
    );
};
export default Icon;
